import React, { ComponentProps } from 'react';
import { styled } from 'styled-components';

import MQ from '@rover/kibble/styles/MediaQuery';

import { Location } from '../../../search/SearchPage/components';

import { FormState } from './filterFormState';

const BaseLocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 10;
`;

// The `&&` selectors fix an issue with hydration errors causing improper styling (see DEV-116863)
const DesktopLocationWrapper = styled(BaseLocationWrapper)`
  && {
    ${MQ.XS_DOWN.toString()} {
      display: none;
    }
  }
`;

const MobileLocationWrapper = styled(BaseLocationWrapper)`
  && {
    display: none;
    font-size: 16px;

    ${MQ.XS_DOWN.toString()} {
      display: flex;
    }
  }
`;

export type TrainingLocationInputProps = {
  props: Omit<ComponentProps<typeof Location>, 'label'>;
  onChange: (arg0: FormState) => void;
};
/**
 * To avoid text flicker when changing the label via the `useMatchMedia` hook,
 * this component renders 2 versions of `Location` with different labels (specific to training),
 * but only displays one at a time through CSS.
 */
const TrainingLocationInput: React.FC<TrainingLocationInputProps['props']> = (props) => (
  // TODO (DEV-104195): Translate labels
  <>
    <DesktopLocationWrapper>
      <Location {...props} label="Training near" />
    </DesktopLocationWrapper>
    <MobileLocationWrapper>
      <Location {...props} label="Show me dog trainers near" />
    </MobileLocationWrapper>
  </>
);
export default TrainingLocationInput;
